import { CommonModule, CurrencyPipe } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { PipesModule } from '@app/pipes';
import { Chart,  ChartConfiguration } from 'chart.js';
import { CountUpModule } from 'ngx-countup';


@Component({
  selector: 'mnf-dashboard-v2-submenu-graphs',
  standalone: true,
  imports: [CommonModule, CountUpModule, PipesModule],
  providers: [CurrencyPipe],
  templateUrl: './dashboard-v2-submenu-graphs.component.html',
  styleUrl: './dashboard-v2-submenu-graphs.component.scss'
})
export class DashboardV2SubmenuGraphsComponent {

  @Input() profitUser: { beneficio_no_referred: number, beneficio_referred: number, rendimientos: number }
  
  totalSum: number = 0;

  private myChart: Chart | undefined;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.profitUser) {
      this.totalSum = this.profitUser?.beneficio_no_referred + this.profitUser?.beneficio_referred + this.profitUser?.rendimientos;
      this.graph();
    }
  }
  
  graph() {
    if (this.myChart) {
      this.myChart.destroy();
    }

    const data = {
      labels: ['Rendimientos', 'Promociones', 'Referidos'],
      datasets: [
        {
          label: '',
          data: [
            this.profitUser?.rendimientos,
            this.profitUser?.beneficio_no_referred,
            this.profitUser?.beneficio_referred,
          ],
          borderWidth: 0,
          backgroundColor: ['#D1E3F1', '#82BAD1', '#003A4C'],
          hoverOffset: 4,
        },
      ],
    };

    const config: ChartConfiguration = {
      type: 'doughnut',
      data: data,
      options: {
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
        },
      },
    };

    const canvas = document.getElementById('myChart') as HTMLCanvasElement;
    if (canvas) {
      this.myChart = new Chart(canvas, config);
    }
  }

}
